import type { CandidateState } from "../../api/client";

// Mirrors the backend's forward-only stage order (db/constraints.py STAGES).
const STAGE_ORDER = [
  "consented",
  "cv_uploaded",
  "mcp_connected",
  "profile_complete",
  "thinking_started",
  "thinking_submitted",
];

export type OverallStatus = "not_started" | "in_progress" | "submitted" | "withdrawn";

export const STATUS_LABEL: Record<OverallStatus, string> = {
  not_started: "Not started",
  in_progress: "In progress",
  submitted: "Submitted",
  withdrawn: "Withdrawn",
};

export function overallStatus(state: CandidateState): OverallStatus {
  if (state.stage === "withdrawn") return "withdrawn";
  if (state.stage === "thinking_submitted") return "submitted";
  if (state.stage === "consented" && !state.cv) return "not_started";
  return "in_progress";
}

export const reached = (state: CandidateState, stage: string) =>
  STAGE_ORDER.indexOf(state.stage) >= STAGE_ORDER.indexOf(stage);
